import { FormattedMessage } from 'react-intl'
import React, { useContext } from 'react'
import { biensTypeAppartement, champsMenuRechercheEnum, toutesLesLocalisations } from '../../modules/resultats-recherche/enums/champsMenuRecherche'
import { WHITE } from '../../theme'
import { ResponsiveContext } from '../../utils/context/ResponsiveContext'
import { INITIAL_FORMULAIRE_RECHERCHE } from '../../modules/resultats-recherche/types/formulaireRechercheModel'
import { makeStyles } from 'tss-react/mui'
import styles from '../../styles'
import { Grid } from '@mui/material'
import Link from '../link/Link'
import links from '../../enums/linksEnum'
import { useNavigate } from 'react-router'

const useStyles = makeStyles<{ isLargeScreen: boolean }>()((theme, { isLargeScreen }) => ({
	...styles(theme),
	messageContainer: {
		marginTop: isLargeScreen ? 65 : 31,
		marginBottom: 30
	},
	titre: {
		...styles(theme).title0,
		fontSize: isLargeScreen ? 115 : 68,
		lineHeight: 'unset',
		color: theme.palette.primary.main,
		marginTop: isLargeScreen ? 60 : 0,
		margin: 0
	},
	sousTitre: {
		...styles(theme).title0,
		fontSize: isLargeScreen ? 65 : 38,
		lineHeight: isLargeScreen ? '75px' : '44px',
		marginTop: 0,
		marginBottom: isLargeScreen ? 26 : 35
	},
	texte: {
		...styles(theme).text2,
		fontSize: isLargeScreen ? 20 : 16,
		lineHeight: '30px',
		marginTop: isLargeScreen ? 0 : 42,
		marginBottom: isLargeScreen ? 41 : 28
	},
	erreurContainer: {
		paddingLeft: isLargeScreen ? 65 : 30,
		paddingRight: isLargeScreen ? 65 : 30,
		background: WHITE,
		paddingTop: 30
	},
	imgContainer: {
		'& img': {
			width: '100%',
			aspectRatio: isLargeScreen ? '485/579' : '364/328',
			maxWidth: isLargeScreen ? 485 : '100%',
			objectFit: 'cover',
			objectPosition: 'left'
		}
	}
}))

const Custom404 = () => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes } = useStyles({ isLargeScreen })
	const navigate = useNavigate()

	return (
		<Grid
			container
			item
			xs={12}
			className={classes.erreurContainer}
		>
			<Grid
				container
				item
				xs={12}
				justifyContent="space-between"
				className={classes.messageContainer}
			>
				<Grid item xs={12} md={6}>
					<p className={classes.titre}>
						<FormattedMessage
							id="404.titre"
							description="Titre de la page 404"
						/>
					</p>

					<p className={classes.sousTitre}>
						<FormattedMessage
							id="404.sousTitre"
							description="Sous titre de la page 404"
						/>
					</p>

					{
						!isLargeScreen && (
							<Grid
								container
								item
								md={5}
								className={classes.imgContainer}
								justifyContent="flex-end"
							>
								<img src="/img/404/erreur404.png" alt="Erreur 404" />
							</Grid>
						)
					}

					<p className={classes.texte}>
						<FormattedMessage
							id="404.texte"
							description="Texte de la page 404"
						/>
					</p>

					<Link
						// Redirection vers la page de résultat de recherche avec un filtre par défaut sur les offres de type "Appartement"
						href={
							`${links.RECHERCHE_OFFRE}?filtres=${
								JSON.stringify({
									...INITIAL_FORMULAIRE_RECHERCHE,
									[champsMenuRechercheEnum.location]: toutesLesLocalisations,
									[champsMenuRechercheEnum.typeBien]: biensTypeAppartement
								})
							}`
						}
						onClick={() => navigate({
							pathname: links.RECHERCHE_OFFRE,
							search: `?filtres=${
								JSON.stringify({
									...INITIAL_FORMULAIRE_RECHERCHE,
									[champsMenuRechercheEnum.location]: toutesLesLocalisations,
									[champsMenuRechercheEnum.typeBien]: biensTypeAppartement
								})
							}`
						})}
						noAnimation
						typeBouton
						textStyle="text4"
						prevent
					>
						<FormattedMessage
							id="404.bouton"
							description="Bouton de la page 404"
						/>
					</Link>
				</Grid>

				{
					isLargeScreen && (
						<Grid
							container
							item
							md={5}
							className={classes.imgContainer}
							justifyContent="flex-end"
						>
							<img src="/img/404/erreur404.png" alt="Erreur 404" />
						</Grid>
					)
				}
			</Grid>
		</Grid>
	)
}

export default Custom404
